module.exports = __webpack_public_path__ + "img/a-00.0a4bdb8f.png";